// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Mafo","delete":"styles_delete__1knBX","update":"styles_update__2RcNB","add":"styles_add__16KYX"};